import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=49e7887a&scoped=true&"
import script from "./skeleton.vue?vue&type=script&lang=js&"
export * from "./skeleton.vue?vue&type=script&lang=js&"
import style0 from "./skeleton.vue?vue&type=style&index=0&id=49e7887a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e7887a",
  null
  
)

export default component.exports